import { useStores } from '../auth/StoreContext';

interface Props {
  // Whether to include an "All stores" option (super-admin, consolidated views).
  allowAll?: boolean;
  value?: number | null;
  onChange?: (id: number | null) => void;
  label?: string;
}

/**
 * Store picker. For super admins it renders a dropdown; for store admins it
 * renders a static chip of their store (they cannot switch). When `value` /
 * `onChange` are omitted it drives the shared StoreContext selection.
 */
export function StoreSelector({
  allowAll = false,
  value,
  onChange,
  label,
}: Props) {
  const { stores, canSwitchStore, selectedStoreId, setSelectedStoreId, currentStore } =
    useStores();

  const current = value !== undefined ? value : selectedStoreId;
  const setCurrent = onChange ?? setSelectedStoreId;

  if (!canSwitchStore) {
    return (
      <div className="row gap-sm">
        {label && <label style={{ margin: 0 }}>{label}</label>}
        <span className="badge badge-gray">
          {currentStore?.name ?? 'Your store'}
        </span>
      </div>
    );
  }

  return (
    <div className="row gap-sm">
      {label && <label style={{ margin: 0 }}>{label}</label>}
      <select
        style={{ width: 'auto', minWidth: 180 }}
        value={current ?? ''}
        onChange={(e) =>
          setCurrent(e.target.value === '' ? null : Number(e.target.value))
        }
      >
        {allowAll && <option value="">All stores</option>}
        {!allowAll && current == null && (
          <option value="" disabled>
            Select a store…
          </option>
        )}
        {stores.map((s) => (
          <option key={s.id} value={s.id}>
            {s.name}
          </option>
        ))}
      </select>
    </div>
  );
}
